import { render, staticRenderFns } from "./LKI03.vue?vue&type=template&id=a09a00ca&scoped=true"
import script from "./LKI03.vue?vue&type=script&lang=js"
export * from "./LKI03.vue?vue&type=script&lang=js"
import style0 from "./LKI03.vue?vue&type=style&index=0&id=a09a00ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09a00ca",
  null
  
)

export default component.exports